<template>
    <el-empty class="cbaas-empty">
        <template slot="image">
            <img-empty />
        </template>
    </el-empty>
</template>
<script>
import ImgEmpty from './img-empty.vue';

export default {
    name: 'Empty',
    components: {
        ImgEmpty: ImgEmpty
    },
    data() {
        return {

        };
    }
};
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme('cbaas-empty', (
    --cbaas-empty-svg-fill: #dcdde0,
    --cbaas-empty-description-color: #A3AFB5,
), (
    --cbaas-empty-svg-fill: #A3AFB5,
    --cbaas-empty-description-color: #122836,
));
.el-empty.cbaas-empty {
    @include adaptation(( 
        --cbaas-empty-padding: 40px 0,
        --cbaas-empty-image-width: 200px,
        --cbaas-empty-description-margin-top: 8px,
        --cbaas-empty-description-fontsize: 12px,
        --cbaas-empty-bottom-margin-top: 20px,
    ));
    padding: var(--cbaas-empty-padding);

    /deep/ {
        .el-empty__image {
            width: var(--cbaas-empty-image-width);

            svg {
                fill: var(--cbaas-empty-svg-fill);
            }
        }

        .el-empty__description {
            margin-top: var(--cbaas-empty-description-margin-top);

            p {
                color: var(--cbaas-empty-description-color);
                font-size: var(--cbaas-empty-description-fontsize);
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }

        .el-empty__bottom {
            margin-top: var(--cbaas-empty-bottom-margin-top);
        }
    }
}
</style>